export default "__VITE_ASSET__sdiaKAM7__"